// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/skill.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { CreateSkillPayload, CreateSkillVersionPayload, PromoteSkillVersionPayload, PutSkillVersionFilePayload, Skill, SkillFile, SkillFileContent, SkillGroup, SkillGroupClass, SkillVersion, UpdateSkillPayload, UpdateSkillVersionContentPayload } from "../v1/skill_pb.js";
import { file_agentplatform_v1_skill } from "../v1/skill_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/skill.proto.
 */
export const file_agentplatform_httpv2_skill: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_skill, file_buf_validate_validate, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesResponse
 */
export type ListSkillGroupClassesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesData data = 4;
   */
  data?: ListSkillGroupClassesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesResponse.
 * Use `create(ListSkillGroupClassesResponseSchema)` to create a new message.
 */
export const ListSkillGroupClassesResponseSchema: GenMessage<ListSkillGroupClassesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 0);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesData
 */
export type ListSkillGroupClassesData = Message<"infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillGroupClass items = 1;
   */
  items: SkillGroupClass[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillGroupClassesData.
 * Use `create(ListSkillGroupClassesDataSchema)` to create a new message.
 */
export const ListSkillGroupClassesDataSchema: GenMessage<ListSkillGroupClassesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassRequest
 */
export type CreateSkillGroupClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassRequest"> & {
  /**
   * 技能组类定义（归属由服务端从鉴权信息回填）
   * @gotags: json:"skillgroup_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroupClass skillgroup_class = 1 [json_name = "skillgroup_class"];
   */
  skillgroupClass?: SkillGroupClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassRequest.
 * Use `create(CreateSkillGroupClassRequestSchema)` to create a new message.
 */
export const CreateSkillGroupClassRequestSchema: GenMessage<CreateSkillGroupClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassResponse
 */
export type CreateSkillGroupClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroupClass data = 4;
   */
  data?: SkillGroupClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillGroupClassResponse.
 * Use `create(CreateSkillGroupClassResponseSchema)` to create a new message.
 */
export const CreateSkillGroupClassResponseSchema: GenMessage<CreateSkillGroupClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillGroupClassRequest
 */
export type GetSkillGroupClassRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSkillGroupClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillGroupClassRequest.
 * Use `create(GetSkillGroupClassRequestSchema)` to create a new message.
 */
export const GetSkillGroupClassRequestSchema: GenMessage<GetSkillGroupClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillGroupClassResponse
 */
export type GetSkillGroupClassResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSkillGroupClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroupClass data = 4;
   */
  data?: SkillGroupClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillGroupClassResponse.
 * Use `create(GetSkillGroupClassResponseSchema)` to create a new message.
 */
export const GetSkillGroupClassResponseSchema: GenMessage<GetSkillGroupClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassRequest
 */
export type UpdateSkillGroupClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassRequest"> & {
  /**
   * 待更新技能组类 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 技能组类定义（id / 归属由服务端回填）
   * @gotags: json:"skillgroup_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroupClass skillgroup_class = 2 [json_name = "skillgroup_class"];
   */
  skillgroupClass?: SkillGroupClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassRequest.
 * Use `create(UpdateSkillGroupClassRequestSchema)` to create a new message.
 */
export const UpdateSkillGroupClassRequestSchema: GenMessage<UpdateSkillGroupClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassResponse
 */
export type UpdateSkillGroupClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroupClass data = 4;
   */
  data?: SkillGroupClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupClassResponse.
 * Use `create(UpdateSkillGroupClassResponseSchema)` to create a new message.
 */
export const UpdateSkillGroupClassResponseSchema: GenMessage<UpdateSkillGroupClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassRequest
 */
export type DeleteSkillGroupClassRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassRequest.
 * Use `create(DeleteSkillGroupClassRequestSchema)` to create a new message.
 */
export const DeleteSkillGroupClassRequestSchema: GenMessage<DeleteSkillGroupClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 8);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassResponse
 */
export type DeleteSkillGroupClassResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupClassResponse.
 * Use `create(DeleteSkillGroupClassResponseSchema)` to create a new message.
 */
export const DeleteSkillGroupClassResponseSchema: GenMessage<DeleteSkillGroupClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillGroupsResponse
 */
export type ListSkillGroupsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSkillGroupsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSkillGroupsData data = 4;
   */
  data?: ListSkillGroupsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillGroupsResponse.
 * Use `create(ListSkillGroupsResponseSchema)` to create a new message.
 */
export const ListSkillGroupsResponseSchema: GenMessage<ListSkillGroupsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 10);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillGroupsData
 */
export type ListSkillGroupsData = Message<"infinigence.infini.agentplatform.httpv2.ListSkillGroupsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillGroup items = 1;
   */
  items: SkillGroup[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillGroupsData.
 * Use `create(ListSkillGroupsDataSchema)` to create a new message.
 */
export const ListSkillGroupsDataSchema: GenMessage<ListSkillGroupsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillGroupRequest
 */
export type CreateSkillGroupRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillGroupRequest"> & {
  /**
   * 技能组定义（归属由服务端从鉴权信息回填）
   * @gotags: json:"skillgroup"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup skillgroup = 1;
   */
  skillgroup?: SkillGroup | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillGroupRequest.
 * Use `create(CreateSkillGroupRequestSchema)` to create a new message.
 */
export const CreateSkillGroupRequestSchema: GenMessage<CreateSkillGroupRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillGroupResponse
 */
export type CreateSkillGroupResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillGroupResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup data = 4;
   */
  data?: SkillGroup | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillGroupResponse.
 * Use `create(CreateSkillGroupResponseSchema)` to create a new message.
 */
export const CreateSkillGroupResponseSchema: GenMessage<CreateSkillGroupResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillGroupRequest
 */
export type GetSkillGroupRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSkillGroupRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillGroupRequest.
 * Use `create(GetSkillGroupRequestSchema)` to create a new message.
 */
export const GetSkillGroupRequestSchema: GenMessage<GetSkillGroupRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillGroupResponse
 */
export type GetSkillGroupResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSkillGroupResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup data = 4;
   */
  data?: SkillGroup | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillGroupResponse.
 * Use `create(GetSkillGroupResponseSchema)` to create a new message.
 */
export const GetSkillGroupResponseSchema: GenMessage<GetSkillGroupResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupRequest
 */
export type UpdateSkillGroupRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillGroupRequest"> & {
  /**
   * 待更新技能组 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 技能组定义（id / 归属由服务端回填）
   * @gotags: json:"skillgroup"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup skillgroup = 2;
   */
  skillgroup?: SkillGroup | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupRequest.
 * Use `create(UpdateSkillGroupRequestSchema)` to create a new message.
 */
export const UpdateSkillGroupRequestSchema: GenMessage<UpdateSkillGroupRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupResponse
 */
export type UpdateSkillGroupResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillGroupResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup data = 4;
   */
  data?: SkillGroup | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillGroupResponse.
 * Use `create(UpdateSkillGroupResponseSchema)` to create a new message.
 */
export const UpdateSkillGroupResponseSchema: GenMessage<UpdateSkillGroupResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupRequest
 */
export type DeleteSkillGroupRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillGroupRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupRequest.
 * Use `create(DeleteSkillGroupRequestSchema)` to create a new message.
 */
export const DeleteSkillGroupRequestSchema: GenMessage<DeleteSkillGroupRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 18);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupResponse
 */
export type DeleteSkillGroupResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillGroupResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillGroupResponse.
 * Use `create(DeleteSkillGroupResponseSchema)` to create a new message.
 */
export const DeleteSkillGroupResponseSchema: GenMessage<DeleteSkillGroupResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillsResponse
 */
export type ListSkillsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSkillsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSkillsData data = 4;
   */
  data?: ListSkillsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillsResponse.
 * Use `create(ListSkillsResponseSchema)` to create a new message.
 */
export const ListSkillsResponseSchema: GenMessage<ListSkillsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 20);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillsData
 */
export type ListSkillsData = Message<"infinigence.infini.agentplatform.httpv2.ListSkillsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Skill items = 1;
   */
  items: Skill[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillsData.
 * Use `create(ListSkillsDataSchema)` to create a new message.
 */
export const ListSkillsDataSchema: GenMessage<ListSkillsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillRequest
 */
export type GetSkillRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSkillRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * 是否携带版本列表
   * @gotags: json:"with_versions,omitempty"
   *
   * @generated from field: bool with_versions = 2 [json_name = "with_versions"];
   */
  withVersions: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillRequest.
 * Use `create(GetSkillRequestSchema)` to create a new message.
 */
export const GetSkillRequestSchema: GenMessage<GetSkillRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillResponse
 */
export type GetSkillResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSkillResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Skill data = 4;
   */
  data?: Skill | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillResponse.
 * Use `create(GetSkillResponseSchema)` to create a new message.
 */
export const GetSkillResponseSchema: GenMessage<GetSkillResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillRequest
 */
export type CreateSkillRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillRequest"> & {
  /**
   * 创建技能载荷（归属 / author 由服务端回填）
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.CreateSkillPayload request = 1;
   */
  request?: CreateSkillPayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillRequest.
 * Use `create(CreateSkillRequestSchema)` to create a new message.
 */
export const CreateSkillRequestSchema: GenMessage<CreateSkillRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillResponse
 */
export type CreateSkillResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Skill data = 4;
   */
  data?: Skill | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillResponse.
 * Use `create(CreateSkillResponseSchema)` to create a new message.
 */
export const CreateSkillResponseSchema: GenMessage<CreateSkillResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ForkSkillRequest
 */
export type ForkSkillRequest = Message<"infinigence.infini.agentplatform.httpv2.ForkSkillRequest"> & {
  /**
   * 源技能 ID
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * 源技能版本号（0 = 使用默认版本）
   * @gotags: json:"skill_version_code,omitempty"
   *
   * @generated from field: int32 skill_version_code = 2 [json_name = "skill_version_code"];
   */
  skillVersionCode: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ForkSkillRequest.
 * Use `create(ForkSkillRequestSchema)` to create a new message.
 */
export const ForkSkillRequestSchema: GenMessage<ForkSkillRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ForkSkillResponse
 */
export type ForkSkillResponse = Message<"infinigence.infini.agentplatform.httpv2.ForkSkillResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Skill data = 4;
   */
  data?: Skill | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ForkSkillResponse.
 * Use `create(ForkSkillResponseSchema)` to create a new message.
 */
export const ForkSkillResponseSchema: GenMessage<ForkSkillResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillRequest
 */
export type UpdateSkillRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillRequest"> & {
  /**
   * 待更新技能 ID
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * 更新技能载荷（归属 / author 由服务端回填）
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.UpdateSkillPayload request = 2;
   */
  request?: UpdateSkillPayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillRequest.
 * Use `create(UpdateSkillRequestSchema)` to create a new message.
 */
export const UpdateSkillRequestSchema: GenMessage<UpdateSkillRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 28);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillResponse
 */
export type UpdateSkillResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Skill data = 4;
   */
  data?: Skill | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillResponse.
 * Use `create(UpdateSkillResponseSchema)` to create a new message.
 */
export const UpdateSkillResponseSchema: GenMessage<UpdateSkillResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 29);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillRequest
 */
export type DeleteSkillRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillRequest.
 * Use `create(DeleteSkillRequestSchema)` to create a new message.
 */
export const DeleteSkillRequestSchema: GenMessage<DeleteSkillRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 30);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillResponse
 */
export type DeleteSkillResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillResponse.
 * Use `create(DeleteSkillResponseSchema)` to create a new message.
 */
export const DeleteSkillResponseSchema: GenMessage<DeleteSkillResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 31);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionsRequest
 */
export type ListSkillVersionsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionsRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionsRequest.
 * Use `create(ListSkillVersionsRequestSchema)` to create a new message.
 */
export const ListSkillVersionsRequestSchema: GenMessage<ListSkillVersionsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 32);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionsResponse
 */
export type ListSkillVersionsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSkillVersionsData data = 4;
   */
  data?: ListSkillVersionsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionsResponse.
 * Use `create(ListSkillVersionsResponseSchema)` to create a new message.
 */
export const ListSkillVersionsResponseSchema: GenMessage<ListSkillVersionsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 33);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionsData
 */
export type ListSkillVersionsData = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionsData"> & {
  /**
   * @gotags: json:"versions"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillVersion versions = 1;
   */
  versions: SkillVersion[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionsData.
 * Use `create(ListSkillVersionsDataSchema)` to create a new message.
 */
export const ListSkillVersionsDataSchema: GenMessage<ListSkillVersionsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 34);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillVersionRequest
 */
export type GetSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * 版本号
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 附加返回项（如 content / files；空 = 默认）
   * @gotags: json:"include,omitempty"
   *
   * @generated from field: string include = 3;
   */
  include: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillVersionRequest.
 * Use `create(GetSkillVersionRequestSchema)` to create a new message.
 */
export const GetSkillVersionRequestSchema: GenMessage<GetSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 35);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillVersionResponse
 */
export type GetSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillVersion data = 4;
   */
  data?: SkillVersion | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillVersionResponse.
 * Use `create(GetSkillVersionResponseSchema)` to create a new message.
 */
export const GetSkillVersionResponseSchema: GenMessage<GetSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 36);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillVersionRequest
 */
export type CreateSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * 创建版本载荷
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.CreateSkillVersionPayload request = 2;
   */
  request?: CreateSkillVersionPayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillVersionRequest.
 * Use `create(CreateSkillVersionRequestSchema)` to create a new message.
 */
export const CreateSkillVersionRequestSchema: GenMessage<CreateSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 37);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSkillVersionResponse
 */
export type CreateSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillVersion data = 4;
   */
  data?: SkillVersion | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSkillVersionResponse.
 * Use `create(CreateSkillVersionResponseSchema)` to create a new message.
 */
export const CreateSkillVersionResponseSchema: GenMessage<CreateSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 38);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionRequest
 */
export type DeleteSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionRequest.
 * Use `create(DeleteSkillVersionRequestSchema)` to create a new message.
 */
export const DeleteSkillVersionRequestSchema: GenMessage<DeleteSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 39);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionResponse
 */
export type DeleteSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionResponse.
 * Use `create(DeleteSkillVersionResponseSchema)` to create a new message.
 */
export const DeleteSkillVersionResponseSchema: GenMessage<DeleteSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 40);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentRequest
 */
export type UpdateSkillVersionContentRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 更新正文载荷
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.UpdateSkillVersionContentPayload request = 3;
   */
  request?: UpdateSkillVersionContentPayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentRequest.
 * Use `create(UpdateSkillVersionContentRequestSchema)` to create a new message.
 */
export const UpdateSkillVersionContentRequestSchema: GenMessage<UpdateSkillVersionContentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 41);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentResponse
 */
export type UpdateSkillVersionContentResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillVersion data = 4;
   */
  data?: SkillVersion | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSkillVersionContentResponse.
 * Use `create(UpdateSkillVersionContentResponseSchema)` to create a new message.
 */
export const UpdateSkillVersionContentResponseSchema: GenMessage<UpdateSkillVersionContentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 42);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CloneSkillVersionRequest
 */
export type CloneSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.CloneSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CloneSkillVersionRequest.
 * Use `create(CloneSkillVersionRequestSchema)` to create a new message.
 */
export const CloneSkillVersionRequestSchema: GenMessage<CloneSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 43);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CloneSkillVersionResponse
 */
export type CloneSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.CloneSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillVersion data = 4;
   */
  data?: SkillVersion | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CloneSkillVersionResponse.
 * Use `create(CloneSkillVersionResponseSchema)` to create a new message.
 */
export const CloneSkillVersionResponseSchema: GenMessage<CloneSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 44);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PromoteSkillVersionRequest
 */
export type PromoteSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.PromoteSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 提升载荷（is_stable / is_latest）
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.PromoteSkillVersionPayload request = 3;
   */
  request?: PromoteSkillVersionPayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PromoteSkillVersionRequest.
 * Use `create(PromoteSkillVersionRequestSchema)` to create a new message.
 */
export const PromoteSkillVersionRequestSchema: GenMessage<PromoteSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 45);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PromoteSkillVersionResponse
 */
export type PromoteSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.PromoteSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillVersion data = 4;
   */
  data?: SkillVersion | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PromoteSkillVersionResponse.
 * Use `create(PromoteSkillVersionResponseSchema)` to create a new message.
 */
export const PromoteSkillVersionResponseSchema: GenMessage<PromoteSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 46);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesRequest
 */
export type ListSkillVersionFilesRequest = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesRequest.
 * Use `create(ListSkillVersionFilesRequestSchema)` to create a new message.
 */
export const ListSkillVersionFilesRequestSchema: GenMessage<ListSkillVersionFilesRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 47);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesResponse
 */
export type ListSkillVersionFilesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesData data = 4;
   */
  data?: ListSkillVersionFilesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesResponse.
 * Use `create(ListSkillVersionFilesResponseSchema)` to create a new message.
 */
export const ListSkillVersionFilesResponseSchema: GenMessage<ListSkillVersionFilesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 48);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesData
 */
export type ListSkillVersionFilesData = Message<"infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesData"> & {
  /**
   * @gotags: json:"files"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillFile files = 1;
   */
  files: SkillFile[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSkillVersionFilesData.
 * Use `create(ListSkillVersionFilesDataSchema)` to create a new message.
 */
export const ListSkillVersionFilesDataSchema: GenMessage<ListSkillVersionFilesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 49);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillVersionFileRequest
 */
export type GetSkillVersionFileRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSkillVersionFileRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 文件路径
   * @gotags: json:"file_path"
   *
   * @generated from field: string file_path = 3 [json_name = "file_path"];
   */
  filePath: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillVersionFileRequest.
 * Use `create(GetSkillVersionFileRequestSchema)` to create a new message.
 */
export const GetSkillVersionFileRequestSchema: GenMessage<GetSkillVersionFileRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 50);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSkillVersionFileResponse
 */
export type GetSkillVersionFileResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSkillVersionFileResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillFileContent data = 4;
   */
  data?: SkillFileContent | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSkillVersionFileResponse.
 * Use `create(GetSkillVersionFileResponseSchema)` to create a new message.
 */
export const GetSkillVersionFileResponseSchema: GenMessage<GetSkillVersionFileResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 51);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PutSkillVersionFileRequest
 */
export type PutSkillVersionFileRequest = Message<"infinigence.infini.agentplatform.httpv2.PutSkillVersionFileRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 文件路径
   * @gotags: json:"file_path"
   *
   * @generated from field: string file_path = 3 [json_name = "file_path"];
   */
  filePath: string;

  /**
   * 文件内容载荷
   * @gotags: json:"request"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.PutSkillVersionFilePayload request = 4;
   */
  request?: PutSkillVersionFilePayload | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PutSkillVersionFileRequest.
 * Use `create(PutSkillVersionFileRequestSchema)` to create a new message.
 */
export const PutSkillVersionFileRequestSchema: GenMessage<PutSkillVersionFileRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 52);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.PutSkillVersionFileResponse
 */
export type PutSkillVersionFileResponse = Message<"infinigence.infini.agentplatform.httpv2.PutSkillVersionFileResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillFile data = 4;
   */
  data?: SkillFile | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.PutSkillVersionFileResponse.
 * Use `create(PutSkillVersionFileResponseSchema)` to create a new message.
 */
export const PutSkillVersionFileResponseSchema: GenMessage<PutSkillVersionFileResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 53);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileRequest
 */
export type DeleteSkillVersionFileRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * 文件路径
   * @gotags: json:"file_path"
   *
   * @generated from field: string file_path = 3 [json_name = "file_path"];
   */
  filePath: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileRequest.
 * Use `create(DeleteSkillVersionFileRequestSchema)` to create a new message.
 */
export const DeleteSkillVersionFileRequestSchema: GenMessage<DeleteSkillVersionFileRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 54);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileResponse
 */
export type DeleteSkillVersionFileResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSkillVersionFileResponse.
 * Use `create(DeleteSkillVersionFileResponseSchema)` to create a new message.
 */
export const DeleteSkillVersionFileResponseSchema: GenMessage<DeleteSkillVersionFileResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 55);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ImportSkillZipRequest
 */
export type ImportSkillZipRequest = Message<"infinigence.infini.agentplatform.httpv2.ImportSkillZipRequest"> & {
  /**
   * zip 文件名
   * @gotags: json:"file_name"
   *
   * @generated from field: string file_name = 1 [json_name = "file_name"];
   */
  fileName: string;

  /**
   * zip 文件内容（base64 编码由 JSON 透传）
   * @gotags: json:"file"
   *
   * @generated from field: bytes file = 2;
   */
  file: Uint8Array;

  /**
   * 目标技能 ID（空 = 新建技能）
   * @gotags: json:"skill_id,omitempty"
   *
   * @generated from field: string skill_id = 3 [json_name = "skill_id"];
   */
  skillId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ImportSkillZipRequest.
 * Use `create(ImportSkillZipRequestSchema)` to create a new message.
 */
export const ImportSkillZipRequestSchema: GenMessage<ImportSkillZipRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 56);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ImportSkillZipResponse
 */
export type ImportSkillZipResponse = Message<"infinigence.infini.agentplatform.httpv2.ImportSkillZipResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ImportSkillZipData data = 4;
   */
  data?: ImportSkillZipData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ImportSkillZipResponse.
 * Use `create(ImportSkillZipResponseSchema)` to create a new message.
 */
export const ImportSkillZipResponseSchema: GenMessage<ImportSkillZipResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 57);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ImportSkillZipData
 */
export type ImportSkillZipData = Message<"infinigence.infini.agentplatform.httpv2.ImportSkillZipData"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 3 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * @gotags: json:"created"
   *
   * @generated from field: bool created = 4;
   */
  created: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ImportSkillZipData.
 * Use `create(ImportSkillZipDataSchema)` to create a new message.
 */
export const ImportSkillZipDataSchema: GenMessage<ImportSkillZipData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 58);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ExportSkillVersionRequest
 */
export type ExportSkillVersionRequest = Message<"infinigence.infini.agentplatform.httpv2.ExportSkillVersionRequest"> & {
  /**
   * @gotags: json:"skill_id"
   *
   * @generated from field: string skill_id = 1 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @gotags: json:"version_code"
   *
   * @generated from field: int32 version_code = 2 [json_name = "version_code"];
   */
  versionCode: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ExportSkillVersionRequest.
 * Use `create(ExportSkillVersionRequestSchema)` to create a new message.
 */
export const ExportSkillVersionRequestSchema: GenMessage<ExportSkillVersionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 59);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ExportSkillVersionResponse
 */
export type ExportSkillVersionResponse = Message<"infinigence.infini.agentplatform.httpv2.ExportSkillVersionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ExportSkillVersionData data = 4;
   */
  data?: ExportSkillVersionData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ExportSkillVersionResponse.
 * Use `create(ExportSkillVersionResponseSchema)` to create a new message.
 */
export const ExportSkillVersionResponseSchema: GenMessage<ExportSkillVersionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 60);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ExportSkillVersionData
 */
export type ExportSkillVersionData = Message<"infinigence.infini.agentplatform.httpv2.ExportSkillVersionData"> & {
  /**
   * zip 文件内容
   * @gotags: json:"data"
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ExportSkillVersionData.
 * Use `create(ExportSkillVersionDataSchema)` to create a new message.
 */
export const ExportSkillVersionDataSchema: GenMessage<ExportSkillVersionData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_skill, 61);

/**
 * SkillHTTPV2Service
 * 技能组类 / 技能组 的 CRUD（DB），以及技能 / 技能版本 / 技能版本文件 / 导入导出（代理到 cortex）。
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service
 */
export const SkillHTTPV2Service: GenService<{
  /**
   * ---- Skill Group Class ----
   * 列出技能组类（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ListSkillGroupClasses
   */
  listSkillGroupClasses: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSkillGroupClassesResponseSchema;
  },
  /**
   * 创建技能组类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.CreateSkillGroupClass
   */
  createSkillGroupClass: {
    methodKind: "unary";
    input: typeof CreateSkillGroupClassRequestSchema;
    output: typeof CreateSkillGroupClassResponseSchema;
  },
  /**
   * 获取单个技能组类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.GetSkillGroupClass
   */
  getSkillGroupClass: {
    methodKind: "unary";
    input: typeof GetSkillGroupClassRequestSchema;
    output: typeof GetSkillGroupClassResponseSchema;
  },
  /**
   * 更新技能组类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.UpdateSkillGroupClass
   */
  updateSkillGroupClass: {
    methodKind: "unary";
    input: typeof UpdateSkillGroupClassRequestSchema;
    output: typeof UpdateSkillGroupClassResponseSchema;
  },
  /**
   * 删除技能组类（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.DeleteSkillGroupClass
   */
  deleteSkillGroupClass: {
    methodKind: "unary";
    input: typeof DeleteSkillGroupClassRequestSchema;
    output: typeof DeleteSkillGroupClassResponseSchema;
  },
  /**
   * ---- Skill Group ----
   * 列出技能组（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ListSkillGroups
   */
  listSkillGroups: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSkillGroupsResponseSchema;
  },
  /**
   * 创建技能组
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.CreateSkillGroup
   */
  createSkillGroup: {
    methodKind: "unary";
    input: typeof CreateSkillGroupRequestSchema;
    output: typeof CreateSkillGroupResponseSchema;
  },
  /**
   * 获取单个技能组
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.GetSkillGroup
   */
  getSkillGroup: {
    methodKind: "unary";
    input: typeof GetSkillGroupRequestSchema;
    output: typeof GetSkillGroupResponseSchema;
  },
  /**
   * 更新技能组
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.UpdateSkillGroup
   */
  updateSkillGroup: {
    methodKind: "unary";
    input: typeof UpdateSkillGroupRequestSchema;
    output: typeof UpdateSkillGroupResponseSchema;
  },
  /**
   * 删除技能组（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.DeleteSkillGroup
   */
  deleteSkillGroup: {
    methodKind: "unary";
    input: typeof DeleteSkillGroupRequestSchema;
    output: typeof DeleteSkillGroupResponseSchema;
  },
  /**
   * ---- Skill（代理到 cortex） ----
   * 列出技能（分页 / 关键字 / 是否公共）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ListSkills
   */
  listSkills: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSkillsResponseSchema;
  },
  /**
   * 获取单个技能
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.GetSkill
   */
  getSkill: {
    methodKind: "unary";
    input: typeof GetSkillRequestSchema;
    output: typeof GetSkillResponseSchema;
  },
  /**
   * 创建技能
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.CreateSkill
   */
  createSkill: {
    methodKind: "unary";
    input: typeof CreateSkillRequestSchema;
    output: typeof CreateSkillResponseSchema;
  },
  /**
   * Fork 技能
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ForkSkill
   */
  forkSkill: {
    methodKind: "unary";
    input: typeof ForkSkillRequestSchema;
    output: typeof ForkSkillResponseSchema;
  },
  /**
   * 更新技能
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.UpdateSkill
   */
  updateSkill: {
    methodKind: "unary";
    input: typeof UpdateSkillRequestSchema;
    output: typeof UpdateSkillResponseSchema;
  },
  /**
   * 删除技能（幂等）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.DeleteSkill
   */
  deleteSkill: {
    methodKind: "unary";
    input: typeof DeleteSkillRequestSchema;
    output: typeof DeleteSkillResponseSchema;
  },
  /**
   * ---- Skill Version（代理到 cortex） ----
   * 列出技能版本
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ListSkillVersions
   */
  listSkillVersions: {
    methodKind: "unary";
    input: typeof ListSkillVersionsRequestSchema;
    output: typeof ListSkillVersionsResponseSchema;
  },
  /**
   * 获取单个技能版本
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.GetSkillVersion
   */
  getSkillVersion: {
    methodKind: "unary";
    input: typeof GetSkillVersionRequestSchema;
    output: typeof GetSkillVersionResponseSchema;
  },
  /**
   * 创建技能版本
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.CreateSkillVersion
   */
  createSkillVersion: {
    methodKind: "unary";
    input: typeof CreateSkillVersionRequestSchema;
    output: typeof CreateSkillVersionResponseSchema;
  },
  /**
   * 删除技能版本（幂等）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.DeleteSkillVersion
   */
  deleteSkillVersion: {
    methodKind: "unary";
    input: typeof DeleteSkillVersionRequestSchema;
    output: typeof DeleteSkillVersionResponseSchema;
  },
  /**
   * 更新技能版本正文
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.UpdateSkillVersionContent
   */
  updateSkillVersionContent: {
    methodKind: "unary";
    input: typeof UpdateSkillVersionContentRequestSchema;
    output: typeof UpdateSkillVersionContentResponseSchema;
  },
  /**
   * 克隆技能版本
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.CloneSkillVersion
   */
  cloneSkillVersion: {
    methodKind: "unary";
    input: typeof CloneSkillVersionRequestSchema;
    output: typeof CloneSkillVersionResponseSchema;
  },
  /**
   * 提升技能版本（stable / latest）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.PromoteSkillVersion
   */
  promoteSkillVersion: {
    methodKind: "unary";
    input: typeof PromoteSkillVersionRequestSchema;
    output: typeof PromoteSkillVersionResponseSchema;
  },
  /**
   * ---- Skill Version File（代理到 cortex） ----
   * 列出技能版本文件
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ListSkillVersionFiles
   */
  listSkillVersionFiles: {
    methodKind: "unary";
    input: typeof ListSkillVersionFilesRequestSchema;
    output: typeof ListSkillVersionFilesResponseSchema;
  },
  /**
   * 获取单个技能版本文件内容
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.GetSkillVersionFile
   */
  getSkillVersionFile: {
    methodKind: "unary";
    input: typeof GetSkillVersionFileRequestSchema;
    output: typeof GetSkillVersionFileResponseSchema;
  },
  /**
   * 写入技能版本文件
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.PutSkillVersionFile
   */
  putSkillVersionFile: {
    methodKind: "unary";
    input: typeof PutSkillVersionFileRequestSchema;
    output: typeof PutSkillVersionFileResponseSchema;
  },
  /**
   * 删除技能版本文件（幂等）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.DeleteSkillVersionFile
   */
  deleteSkillVersionFile: {
    methodKind: "unary";
    input: typeof DeleteSkillVersionFileRequestSchema;
    output: typeof DeleteSkillVersionFileResponseSchema;
  },
  /**
   * ---- Import / Export（代理到 cortex） ----
   * 导入技能 zip 包
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ImportSkillZip
   */
  importSkillZip: {
    methodKind: "unary";
    input: typeof ImportSkillZipRequestSchema;
    output: typeof ImportSkillZipResponseSchema;
  },
  /**
   * 导出技能版本为 zip 包
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SkillHTTPV2Service.ExportSkillVersion
   */
  exportSkillVersion: {
    methodKind: "unary";
    input: typeof ExportSkillVersionRequestSchema;
    output: typeof ExportSkillVersionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_skill, 0);

